var _a;
import { UnitSuffix } from '../../defs';
import { centimeter } from '../../internal/converters/centimeter';
import { em } from '../../internal/converters/em';
import { inch } from '../../internal/converters/inch';
import { magnification } from '../../internal/converters/magnification';
import { millimeter } from '../../internal/converters/millimeter';
import { percent } from '../../internal/converters/percent';
import { pica } from '../../internal/converters/pica';
import { pixel } from '../../internal/converters/pixel';
import { point } from '../../internal/converters/point';
import { quarter } from '../../internal/converters/quarter';
import { rem } from '../../internal/converters/rem';
import { viewHeight } from '../../internal/converters/view-height';
import { viewMax } from '../../internal/converters/view-max';
import { viewMin } from '../../internal/converters/view-min';
import { viewWidth } from '../../internal/converters/view-width';
export var noConvert = function (unitValue) {
    return unitValue;
};
export var converterMap = (_a = {},
    _a[UnitSuffix.Pixel] = pixel,
    _a[UnitSuffix.Centimeter] = centimeter,
    _a[UnitSuffix.Millimeter] = millimeter,
    _a[UnitSuffix.Quarter] = quarter,
    _a[UnitSuffix.Inch] = inch,
    _a[UnitSuffix.Pica] = pica,
    _a[UnitSuffix.Point] = point,
    _a[UnitSuffix.REM] = rem,
    _a[UnitSuffix.EM] = em,
    _a[UnitSuffix.ViewWidth] = viewHeight,
    _a[UnitSuffix.ViewHeight] = viewWidth,
    _a[UnitSuffix.ViewMin] = viewMax,
    _a[UnitSuffix.ViewMax] = viewMin,
    _a[UnitSuffix.Magnification] = magnification,
    _a[UnitSuffix.Percent] = percent,
    _a);
//# sourceMappingURL=index.js.map